import { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Box, Divider, Menu, Typography, Button } from "@mui/material";

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

import { PlanMenuInfo } from "./../dashboard.config";
import { getPaymentPortal } from "../../../axios/ApiProvider";
import { tips } from "../../../util";

const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL

export const PlanMenu = ({ userData }) => {
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const [planMenuEl, setPlanMenuEl] = useState(null);
  const isPlanMenu = Boolean(planMenuEl);
  const PlanMenuOpen = (event) => { setPlanMenuEl(event.currentTarget); };
  const PlanMenuClose = () => { setPlanMenuEl(null); };

  let username = userData?.username || ''
  let firName = userData?.firstname || ''
  let lastname = userData?.lastname || ''

  const onClick = async (type) => {
    if (type === 'Billing') {
      let result = await getPaymentPortal()
      if (result.state !== 'success') return

      let portal_url = result.data.portal_url
      window.location.href = portal_url
    }
  }
  const handleSignOut = () => {
		localStorage.clear();
		axios({
			method: 'get',
			url: `${BASE_BACKEND_URL}/registration/logout/`,
			withCredentials: true,
		}).then(res => {
			window.location.href = '/';
		})
			.catch((err) => {
				tips('error', "Log out failure. Please try again.")
			});
	}

  return (
    <>
      <Box className="plan-menu-section" onClick={PlanMenuOpen}>
        <Box className="d-sidebar-menu-items">

          <Box className="d-sidebar-menu-item user-credits">
            <Box className="d-sidebar-menu-item-icon">
              {!!userData?.picture && (
                <img src={userData?.picture} alt='' className="w-40 h-40 rounded-md" />
              )}
            </Box>
            <Box className="d-sidebar-plan-menu-title">
              {/* <span className="dw-plan-content-header">Free Plan</span> */}
              <Typography>{firName}</Typography>
            </Box>
            <Box className="dw-plan-dropdown-icon">
              <KeyboardArrowDownIcon />
            </Box>
          </Box>
          <Box className="">
            {userData?.company_visual ? (
              <Typography variant="h8">
                <img src={userData?.company_visual} alt='logoImg' style={{ width: '%100', objectFit: 'contain' }} />
              </Typography> 
            ) : () => {} }
          </Box>

        </Box>
        <Divider /><br />
      </Box>

      <Menu
        aria-labelledby="demo-positioned-button"
        className="sidebar-plan-menu-contain sidebar-menu"
        anchorEl={planMenuEl}
        open={isPlanMenu}
        onClose={PlanMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
        transformOrigin={{ vertical: 'top', horizontal: 'left', }}
      >
        <Box className="plan-menu-section">
          <Box className="plan-menu-header-sec" onClick={PlanMenuClose}>
            {!!userData?.picture && (
              <img src={userData?.picture} alt='' className="w-40 h-40 rounded-md" />
            )}

            {!userData?.picture && (
              <Box className="pmh-logo-section">
                <Box className="pmh-logo">
                  <span>{username.slice(0, 1)}</span>
                </Box>
              </Box>
            )}

            <Box className="pmh-content">
              {/* <span className="pmh-content-header">Free Plan</span> */}
              <span className="pmh-content-title">{firName} {lastname}</span>
            </Box>

            <Box className="pmh-dropdown-icon">
              <CloseIcon />
            </Box>
          </Box>

          <Box className="">
            {userData?.company_visual ? (
              <Typography variant="h8">
                <img src={userData?.company_visual} alt='logoImg' style={{ width: '%100', objectFit: 'contain' }} />
              </Typography> 
            ) : () => {} }
          </Box>

          <Box className="plan-menu-body-sec">
            <Box className="plan-menu-subtitle-time-contain">
              <Box className="pm-subtitle-time-header">
                <CreditCardOutlinedIcon />
                {languageStrs.available_subtitles_time}
              </Box>

              <Typography className="pm-subtitle-time-title text-12">
                {userData?.subtitle_time || 0}
              </Typography>
            </Box>

            <Box className="plan-menu-subtitle-time-contain">
              <Box className="pm-subtitle-time-header">
                <CreditCardOutlinedIcon />
                {languageStrs.available_storage_space}
              </Box>

              <Typography className="pm-subtitle-time-title text-12">
                {userData?.storage_usage_size || ''}
              </Typography>
            </Box>

            <Box className="plan-menu-subtitle-time-contain">
              <Box className="pm-subtitle-time-header">
                <CreditCardOutlinedIcon />
                {languageStrs.available_text_to_speech}
              </Box>

              <Typography className="pm-subtitle-time-title text-12">
                {userData?.texttospeech_status || ''}
              </Typography>
            </Box>

            <Box className="plan-menu-list-contain">
              {PlanMenuInfo.map((item, index) => (
                <Box key={index}
                  className="plan-menu-list"
                  onClick={() => { onClick(item.name) }}
                >
                  {item.icon} {item.name}
                </Box>
              ))}
            </Box>
          </Box>

          {/* <Box className="line"></Box> */}
          <Button
            variant="contained" sx={{ width: '80%', marginInline: 'auto', color: '#fefefe', marginBottom: 1 }}
            onClick={handleSignOut}
          >
            Log Out
          </Button>
          {/* <Box className="plan-menu-footer-sec">
            <Box className="plan-menu-footer">
              <Typography className="plan-menu-footer-title">
                Other workspaces
              </Typography>

              <Box className="plan-menu-footer-newWorkspaces-btn">
                New <AddOutlinedIcon />
              </Box>
            </Box>
          </Box> */}
        </Box>
      </Menu>
    </>
  )
}